<template>
  <div class="editPage" v-loading="subLoading">
    <qx-card :title="pageTitle">
      <BaseForm ref="baseForm" @getCombineinfo="getCombineinfo"/>
      <LineForm ref="lineForm" @calcDistance="calcDistance" />
      <CustomerForm ref="customerForm" @calCostPrice="calCostPrice" />
      <CarriageForm ref="carriageForm" @calCostPrice="calCostPrice" />
      <IncomeForm
          ref="incomeForm"
          @calCostPrice="calCostPrice"
          @calPreAndFinalFee="calPreAndFinalFee"
          @changePrePayCash="changePrePayCash"
          @changeAfterPayCash="changeAfterPayCash"
          @changePrePayEquivalenceCardAmount="changePrePayEquivalenceCardAmount"
          @changeAfterPayEquivalenceCardAmount="
            changeAfterPayEquivalenceCardAmount
          "
      />
      <SettlementForm ref="settlementForm" />
      <DemandForm ref="demandForm" />
    </qx-card>
    <SubBtnBox @sub="sub" :comfirmTextName="'发布'" />
  </div>
</template>

<script>
import SubBtnBox from 'components/subBtnBox';
import pageDataMixin from '@qx/mixin/pageData';
import BaseForm from './base';
import LineForm from './line';
import CustomerForm from './customer';
import CarriageForm from './carriage';
import IncomeForm from './income';
import SettlementForm from './settlement';
import DemandForm from './demand';
import {getCarTypeList, getEnumList} from 'api';
import {orderDetail, queryGoodDetail, queryOrderDetail, saveGoods} from 'api/operate';
import {
  fnCalCostPrice,
  fnCalPreAndFinalFee, fnChangeAfterPayCash, fnChangeAfterPayEquivalenceCardAmount,
  fnChangePrePayCash, fnChangePrePayEquivalenceCardAmount,
} from '@/views/manage/operate/orderInput/logged/input/calc';
export default {
  mixins: [
    pageDataMixin,
  ],
  components: {
    SubBtnBox,
    BaseForm,
    LineForm,
    CustomerForm,
    CarriageForm,
    IncomeForm,
    SettlementForm,
    DemandForm,
  },
  data () {
    return {
      pageUrl: '/manage/operate/goods/list/edit',
      formComponents: [
        'baseForm',
        'lineForm',
        'customerForm',
        'carriageForm',
        'incomeForm',
        'settlementForm',
        'demandForm',
      ],
      editParams: {
      },
      subLoading: false,
    };
  },
  computed: {
    detailParams () {
      return {
        id: this.$route.query.id,
      };
    },
  },
  methods: {
    detailApi: queryGoodDetail,
    editApi: saveGoods,
    async handleSubSucc (res) {
      if (res && res.code === 202) {
        this.$alert(res.msg, '温馨提示', {
          confirmButtonText: '我知道了',
        });
      } else {
        this.$message({
          type: 'success',
          message: '发布成功',
        });
      }
      this.close();
      this.subLoading = false;
    },
    async handleDetailSucc () {
      const res = await orderDetail({orderId: this.$route.query.rawOrderId});
      return res;
    },
    // 获取线路+客户信息
    getCombineinfo (combineinfo) {
      for (let formItem of this.formComponents) {
        if (this.$refs[formItem] && this.$refs[formItem].setData) {
          this.$refs[formItem].setData(combineinfo);
        }
      }
    },
    calcDistance ({ state, distance }) {
      if (state === 'start') {
        this.$refs.customerForm.calcIng = true;
        this.$refs.carriageForm.calcIng = true;
      }
      if (state === 'finish') {
        this.$refs.customerForm.calcIng = false;
        this.$refs.carriageForm.calcIng = false;
        this.$refs.customerForm.setDistant(distance);
        this.$refs.carriageForm.setDistant(distance);
      }
    },
    // 计算单价
    calCostPrice () {
      fnCalCostPrice(this);
    },
    // 计算预付和尾款，changeType=1 重新计算；
    calPreAndFinalFee (changeType) {
      fnCalPreAndFinalFee(this, changeType);
    },
    // 改变预付现金
    changePrePayCash () {
      fnChangePrePayCash(this);
    },
    // 改变尾款现金
    changeAfterPayCash () {
      fnChangeAfterPayCash(this);
    },
    // 改变预付等值卡额
    changePrePayEquivalenceCardAmount () {
      fnChangePrePayEquivalenceCardAmount(this);
    },
    // 改变尾款等值卡额
    changeAfterPayEquivalenceCardAmount () {
      fnChangeAfterPayEquivalenceCardAmount(this);
    },
  },
  async mounted () {
    const enumsList = await getEnumList({
      codeType: 'GOODS_TYPE,PRICE_ENUM,EQUIVALENCE_CARD_TYPE,BALANCE_TYPE,DISPATCH_METHOD,RELEASE_SCOPE',
    });
    const vehicleStatusEnumsList = await getCarTypeList();
    const vehicleStatusOptions = [
      { label: '请选择', value: '-1' },
      ...vehicleStatusEnumsList,
    ];
    const priceEnumOptions = [
      ...enumsList[1],
    ];
    const cardTypeOptions = [
      { label: '请选择卡类型', value: '-1' },
      ...enumsList[2],
    ];
    const balanceTypeOptions = [
      // { label: '请选择', value: '-1' },
      ...enumsList[3],
    ];
    const dispatchMethodOptions = [
      ...enumsList[4],
    ];
    const releaseScopeOptions = [
      ...enumsList[5],
    ];
    this.$refs.carriageForm && this.$refs.carriageForm.setList([enumsList[0], vehicleStatusOptions]);
    this.$refs.incomeForm && this.$refs.incomeForm.setList([priceEnumOptions, cardTypeOptions]);
    this.$refs.settlementForm && this.$refs.settlementForm.setList(balanceTypeOptions);
    this.$refs.demandForm && this.$refs.demandForm.setList([dispatchMethodOptions, releaseScopeOptions]);
    this.getData();
  },
};
</script>

<style scoped>

</style>
